import React, { Component } from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import xss from "xss";

import { Navigate, useNavigate } from "../utils/components/router";
import { BeendenButton, Timeout, BigButton } from "../utils/components";
import CONFIG from "../config";
import Home from "../home";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import { configActions, kundenActions, basketActions, metalsActions, currenciesActions } from "../actions";
import KundenDaten from "../Mitarbeiter/components/KundenDaten";
import { scrollToTop, isAuthenticated, checkRageRight, console, sendError } from "../utils/functions";

class Landingpage extends Component {  
  constructor(props) {
    super(props);
    this.state = { error: null, loaded: false, customerIdentified: false, enterWithoutIdError: false };
    this.setAnkaufShop = this.setAnkaufShop.bind(this);
    this.setVerkaufShop = this.setVerkaufShop.bind(this);
    this.setKundenShop = this.setKundenShop.bind(this);
    this.setAdministration = this.setAdministration.bind(this);
    this.setAuftraege = this.setAuftraege.bind(this);
    this.setKursliste = this.setKursliste.bind(this);
    this.setPreisliste = this.setPreisliste.bind(this);
    this.handleResize = this.handleResize.bind(this);  
    this.refForIframeHeight = React.createRef();  
  }

  componentDidMount() {
    if ((this.props.configStorage.isDeuBa() || this.props.configStorage.isVerseNeo()) && !this.props.configStorage.isVerwaltung() && this.props.configStorage.getRenderLandingPage()) {
      this.getAndSetKundenDaten(this.props.kundenStorage.getKundenId());
    }
    if (this.props.configStorage.isVerwaltung()) {
      this.props.dispatch(basketActions.fetchMasterData(this.props.configStorage.getRequestData("masterdata")));
    }
    
    if (this.props.configStorage.isVerseNeo()) {
      this.handleResize();
      setTimeout(() => {        
        this.handleResize();        
      }, 2000);       
      window.addEventListener('resize', this.handleResize);
    }

    scrollToTop();
  }
  
  handleResize() {
    if (window.innerWidth < 500) {
      const iframe = window.parent.document.getElementsByTagName('iframe')[0];
      if (iframe && this.refForIframeHeight && this.refForIframeHeight.current) {        
        let iFrameHeight = this.refForIframeHeight.current.scrollHeight;
        console.log("Component height from ref: " + iFrameHeight);
        
        if (iFrameHeight < 850)  {
          iframe.style.height = '1002px'; 
        } else {
          iframe.style.height = iFrameHeight + 'px';  
        }
        console.log("Reset iframe height to: " + iframe.style.height);
      } else {
        console.log("Rendering to slow. No size available. Use static height 1000px");
        iframe.style.height = '1001px'; 
      }
    }
  }  

  componentWillUnmount() {
    if (this.props.configStorage.isVerseNeo()) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  async setAppIdAndGetData(appId, navigateLink) {
    this.setState({ error: null });
    await this.props.dispatch(configActions.setAppId(appId));
    try {
      await this.props.dispatch(basketActions.setOrderLimit());
      let res2 = await this.props.dispatch(basketActions.fetchMasterData(this.props.configStorage.getRequestData("masterdata")));
      if (res2 && res2.error) {
        console.error("e2", res2.error);
        return;
      }
    } catch (e) {
      console.error("e3", e);
      sendError(e, "landing-page");
      this.setState({ error: e });
      return;
    }
    if (this.props.configStorage.isVerwaltung()) {
      return this.props.navigate(navigateLink);
    }

    const kunde = this.props.kundenStorage.getKunde();
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde", "post", { kunde });
    requestDataKundenEntry.url = requestDataKundenEntry.url + xss(kunde.id);
    const dataAction = CONFIG.getShopConfig({
      edelmetall: metalsActions,
      sorten: currenciesActions
    });
    await Promise.all([
      this.props.dispatch(kundenActions.editEntryLandingPage(requestDataKundenEntry, requestDataKundenEntry.json)),
      this.props.dispatch(dataAction.fetchBaseData(this.props.configStorage.getRequestData("basedata"))),
      this.props.dispatch(dataAction.fetchListData(this.props.configStorage.getRequestData("catalog"))),
      this.props.dispatch(basketActions.setCurrentShopIsAnkauf(this.props.configStorage.isAnkaufShop()))
    ])
      .then(_result => {
        this.props.dispatch(configActions.setRenderLandingPage(false));
        this.props.navigate(navigateLink);
      })
      .catch(err => {
        console.error("e4", err);
        sendError(err, "landing-page");
        this.setState({ error: err });
      });
  }

  setAnkaufShop() {
    if (this.props.configStorage.isDeuBa() && (this.props.configStorage.isCallcenter() || checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_DEUBA_CALLCENTER])) && !this.state.customerIdentified ) {
      this.setEnterWithoutIdError(true);
      return;
    }
    this.setAppIdAndGetData(CONFIG.applicationIdAnkauf, CONFIG.REDIRECT_BUY);
  }

  setVerkaufShop() {
    if (this.props.configStorage.isDeuBa() && (this.props.configStorage.isCallcenter() || checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_DEUBA_CALLCENTER])) && !this.state.customerIdentified ) {
      this.setEnterWithoutIdError(true);
      return;
    }
    this.setAppIdAndGetData(CONFIG.applicationId, CONFIG.REDIRECT_SELL);
  }

  setKundenShop() {
    this.setAppIdAndGetData(CONFIG.applicationId, CONFIG.LINK_BACK_TO_SHOP);
  }

  setAdministration() {
    this.setAppIdAndGetData(CONFIG.applicationId, CONFIG.LINK_ADMIN_PAGE);
  }

  setAuftraege() {
    this.setAppIdAndGetData(CONFIG.applicationId, CONFIG.LINK_ADMIN_PAGE + "?active=auftraege");
  }

  setPreisliste() {
    this.setAppIdAndGetData(CONFIG.applicationId, CONFIG.LINK_ADMIN_PAGE + "?active=kursliste&select=edelmetall");
  }

  setKursliste() {
    this.setAppIdAndGetData(CONFIG.applicationId, CONFIG.LINK_ADMIN_PAGE + "?active=kursliste&select=sorten");
  }

  async getAndSetKundenDaten(kundenId) {
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    try {
      let kundenDaten = await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry));
      this.setState({ kunde: kundenDaten, loaded: true });
      if (this.props.configStorage.isKundenShop()) {
        this.props.dispatch(configActions.setActiveTimeout(false));
      }
    } catch (e) {
      console.error("e5", e);
      sendError(e, "landing-page");
      this.setState({ error: e, loaded: true });
    }
  }    

  setCustomerIdentified(e) {
    this.setState({ customerIdentified: e.target.checked })
    if (e.target.checked) {
      this.setEnterWithoutIdError(false);
    }
  }

  setEnterWithoutIdError(value) {
    this.setState({ enterWithoutIdError: value })
  }

  showShopButtons() {    
    if (this.props.configStorage.isDeuBa() && (this.props.configStorage.isCallcenter() || checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_DEUBA_CALLCENTER]))) {
      return this.state.customerIdentified;
    } else {
      return true;
    }
  }

  render() {
    const kunde = this.props.kundenStorage.getKunde();
    if (
      (!this.props.configStorage.isVerseNeo() && !this.props.configStorage.isDeuBa()) ||
      !this.props.configStorage.getRenderLandingPage()
    ) {
      if (this.props.configStorage.isTanAuth()) {
        const params = new URL(window.location).searchParams;
        let token = xss(params.get("token")) || undefined;
        let tanState = xss(params.get("state")) || undefined;
        let iss = xss(params.get("iss")) || undefined;
        let issuerUrl = xss(params.get("issuerUrl")) || undefined;
        let error = xss(params.get("error")) || undefined;
        let errorDesc = xss(params.get("error_description")) || undefined;
        return <Navigate
          to={this.props.configStorage.getContextPath(CONFIG.LINK_KUNDE_TAN_AUTH)}
          search={{ token, state: tanState, iss, issuerUrl, error, errorDesc }}
        />;
      } else {
        return <Home />;
      }
    }
    const showPreisliste = this.props.configStorage.getShopListe().includes("edelmetall");
    const showKursliste = this.props.configStorage.getShopListe().includes("sorten");
    if (!isAuthenticated(this.props)) {
      return (
        < div className="bootstrap-iso">
          {this.state.loaded
            ? <div className="alert alert-danger">
              Sie haben nicht die benötigten Rechte für die Anwendung
            </div>
            : <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
          <BeendenButton className="col-3 me-one" />
          <div className="d-md-none buffer-area-landing"></div>
        </div>
      );
    }    
    const isVerwaltung = this.props.configStorage.isVerwaltung();
    let content = null;
    if (kunde && !isVerwaltung && checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI])) {
      content = (        
        <div className="d-flex flex-column">          
          <div className="col-12 fs-sm-6">
            <Timeout />
            <KundenDaten
              renderDropdown={!this.props.configStorage.isDeuBa()}
            />
          </div>
          { this.props.configStorage.isDeuBa() && (this.props.configStorage.isCallcenter() || checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_DEUBA_CALLCENTER])) ? 
            (    
              <div className="row my-3">
                <div className="col-12 ps-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="customerIdentifiedCheck"
                      checked={this.state.customerIdentified}
                      onChange={ (e) => this.setCustomerIdentified(e)}
                    />
                    <label className="form-check-label" htmlFor="customerIdentifiedCheck">
                      Legitimation und Verfügungsberechtigung wurden geprüft
                    </label>
                  </div>
                </div>
              </div>
            ) : null
          }
          {this.state.enterWithoutIdError &&
             <div className="alert alert-danger">Bitte bestätigen sie zuerst, dass Legitimation und Verfügungsberechtigung geprüft wurden.</div>
          }
          <div className="mb-two d-flex">            
            {!this.props.configStorage.isKundenShop() && !(this.props.configStorage.isCallcenter() || checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_DEUBA_CALLCENTER]))
              ? <BigButton
                className="col-3 me-one"
                disabled={(kunde.gebietsansaessigKz === 0 || kunde.gebietsansaessigKz === 1) && this.props.kundenStorage.isKontoSelected() ? false : true}
                onClick={this.setAnkaufShop}
                tooltip="Die Ware wird vom Kunden für die Verwertung angekauft"
              > Ankauf
              </BigButton>
              : null
            }
            <BigButton
              className="col-3 me-one"
              disabled={(kunde.gebietsansaessigKz === 0 || kunde.gebietsansaessigKz === 1) && this.props.kundenStorage.isKontoSelected() ? false : true}
              onClick={this.setVerkaufShop}
              tooltip="Die Ware wird für den Kunden bestellt"
            > Bestellung
            </BigButton>
            <BeendenButton />
          </div>          
          <div className="d-md-none buffer-area"></div>
        </div>        
      );
    } else if (kunde && !isVerwaltung && this.props.authenticationStorage.isSignedIn) {
      content = (
        <div ref={this.refForIframeHeight}>
          <div className="col-12 fs-sm-6">
            <Timeout />
            <KundenDaten
              renderDropdown={!this.props.configStorage.isDeuBa()}
            />
          </div>
          <div className="mb-two d-flex">
            <BigButton
              className="col-5 col-sm-3 me-one"
              disabled={(kunde.gebietsansaessigKz === 0 || kunde.gebietsansaessigKz === 1) && this.props.kundenStorage.isKontoSelected() ? false : true}
              onClick={this.setKundenShop}
              tooltip="Ware aus dem Shop bestellen"
            > Bestellung
            </BigButton>
            <BeendenButton />
          </div>
          <div className="d-md-none buffer-area"></div>
        </div>
      );
    } else if (isVerwaltung) {
      content = (
        <>
          <div className="row gap-one g-0 pb-two h-100">
            {checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_ADMIN])
              ? <BigButton
                className="col-4"
                disabled={false}
                onClick={this.setAdministration}
                tooltip="Konfigurieren Sie die Parameter des Shops."
              > Zum Admin-Center
              </BigButton>
              : null
            }
            <BigButton
              className="col-4"
              disabled={false}
              tooltip="Verwalten von erteilten Aufträgen (Zweitdruck/Storno)"
              onClick={this.setAuftraege}
            >
              Zur Auftragsübersicht
            </BigButton>
            {showPreisliste
              ? <BigButton
                className="col-4"
                disabled={false}
                tooltip="Anzeige der Preisleiste für alle Edelmetalle im Ankauf und Verkauf"
                onClick={this.setPreisliste}
              >
                Zur Preisliste Edelmetall
              </BigButton>
              : null
            }
            {showKursliste
              ? <BigButton
                className="col-4"
                disabled={false}
                tooltip="Anzeige der Kursliste für alle Sorten im Ankauf und Verkauf"
                onClick={this.setKursliste}
              >
                Zur Kursliste Sorten
              </BigButton>
              : null
            }
          </div>
          <BeendenButton className="col-3 me-one" />
        </>
      );
    } else if (checkRageRight(this.props.rightStorage.currentRight, [RAGE_RIGHT.RAGE_ADMIN])) {
      content = (
        <>
          {this.state.loaded
            ? <>
              <div className="alert alert-danger">
                Sie haben nicht die benötigten Rechte für die Anwendung
              </div>
              <BeendenButton className="col-3 me-one" />
            </>
            : null
          }
        </>
      );
    }
    return <div className="bootstrap-iso grid-top">
      <h1>Startseite</h1>
      {this.state.error
        ? <div className="alert alert-danger">{this.state.error.message}</div>
        : null
      }
      {content
        ? content
        : <>
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <BeendenButton />
        </>
      }
    </div>;
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage,
    rightStorage: store.rightStorage,
    kundenStorage: store.kundenStorage,
    authenticationStorage: store.authenticationStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI, RAGE_RIGHT.RAGE_ADMIN]
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <Landingpage navigate={contextNavigate} {...props} />;
});
